import {
  AbsolutePositionAligner,
  Share,
  useDocumentClick,
  useLatest,
} from '@sgcmpteltd/uikit-react';
import {
  alignBottomXEnd,
} from '@sgcmpteltd/uikit-react/utils/position/absolute';
import { useRef, useState } from 'react';

import { SHARE_LINK_ICON_SIZE } from './constants';
import { Menu } from './menu';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ShareUrlButton: Component = ({
  link,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const shareUrlButtonElRef = useRef<HTMLButtonElement | null>(null);

  const {
    ref: onDocumentClickRef,
  } = useLatest<Document['onclick']>({
    value: ({ target }) => {
      const { current: shareUrlButtonEl } = shareUrlButtonElRef;

      if (
        !shareUrlButtonEl
        || !(target instanceof HTMLElement)
        || !document.documentElement.contains(target)
        || shareUrlButtonEl.contains(target)
      ) {
        return;
      }

      setIsMenuOpen(false);
    },
  });

  useDocumentClick({
    onClickRef: onDocumentClickRef,
  });

  return (
    <AbsolutePositionAligner
      isActive={isMenuOpen}
      rectCalculator={alignBottomXEnd}
      targetElement={(
        <Menu
          link={link} />
      )}>
      <button
        ref={shareUrlButtonElRef}
        className={styles.containerRoot}
        onClick={() => {
          setIsMenuOpen(true);
        }}>
        <div
          className={styles.containerShareLinkIcon}>
          <Share
            size={SHARE_LINK_ICON_SIZE} />
        </div>
        Share
      </button>
    </AbsolutePositionAligner>
  );
};
